import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Image from 'next/image';

import serverError from '@/assets/serverError.png';
import aproLogo from '@/assets/AproLogo.svg';
import arrow from '@/assets/Arrow.svg';
import { Theme } from '@/UI';
import { brandTheme } from '@/UI/Theme/brandTheme';
import * as St from './Custom500.styles';
import { GlobalContentLayout } from '@/components/Layouts';

const Custom500: FC = () => {
  const { t } = useTranslation();

  return (
    <Theme brandTheme={brandTheme}>
      <GlobalContentLayout>
        <St.Nav>
          <Image
            height={34}
            loader={() => '/AproLogo.svg'}
            src={aproLogo}
            width={174}
            onClick={() => {
              window.location.href = 'https://agendapro.com';
            }}
          />
        </St.Nav>
        <St.Body>
          <St.Container>
            <St.Left>
              <St.Imgage src={serverError} />
            </St.Left>
            <St.Right>
              <St.Arrow src={arrow} />
              <St.Title weight="bold" size="headline">
                {t('500.TITLE')}
              </St.Title>
              <St.Text size="subHeadline" weight="regular">
                {t('500.TEXT')}
              </St.Text>
              <St.StyledButton
                onClick={() => {
                  window.location.href = 'https://agendapro.com';
                }}
              >
                {t('500.BUTTON_TEXT')}
              </St.StyledButton>
            </St.Right>
          </St.Container>
        </St.Body>
      </GlobalContentLayout>
    </Theme>
  );
};

export default Custom500;
